module.exports = __webpack_public_path__ + "img/play-circle.36f0e6ee.svg";